/* =========================================================
PANEL LED V4 — R29-V4-R4
EXPERT NORA SECOND-COMPARISON RECOVERY
SEPARATE GUARDED ASSET

NEW FILE:
assets/panel-led-v4.nora-expert-recovery.js

LOAD AFTER:
panel-led-v4.nora-expert.js

PURPOSE:
- Recover expert_comment NORA after sticky dock / second comparison rerender.
- Preserve mobile approved layout.
- Use desktop Alternative 1: NORA inside Satın Alma Kararı card.
- Use the current CDN URL already owned by panel-led-v4.nora-expert.js.

IMPORTANT:
- Does not hard-code or replace CDN URL.
- No MutationObserver.
- No setInterval.
- Bounded retries only.
========================================================= */
(function (window, document) {
  "use strict";

  var READY_KEY =
    "GDX_PANEL_V4_R29_V4_R4_RECOVERY_READY";

  if (window[READY_KEY]) {
    return;
  }

  window[READY_KEY] = true;

  var STYLE_ID =
    "gdx-panel-v4-r29-v4-r4-recovery-layout";

  var PANEL_SELECTOR =
    '[data-gdx-panel-expert-comment="1"]';

  var LAYOUT_SELECTOR =
    '[data-gdx-panel-r29-v4-layout="1"]';

  var CONTENT_SELECTOR =
    '[data-gdx-panel-r29-v4-expert-content="1"]';

  var HOST_SELECTOR =
    '[data-gdx-panel-r29v-persona="expert_comment"]';

  var IMAGE_SELECTOR =
    '[data-gdx-panel-r29v-image="expert_comment"]';

  var DECISION_ATTR =
    "data-gdx-panel-r29-v4-r4-decision-card";

  var MODE_ATTR =
    "data-gdx-panel-r29-v4-r4-mode";

  var delays =
    [0, 100, 240, 480, 780, 1180, 1700, 2400, 3200];

  var runToken = 0;

  function clean(value) {
    return String(value == null ? "" : value)
      .replace(/\u00a0/g, " ")
      .replace(/\u202f/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function upper(value) {
    return clean(value)
      .toLocaleUpperCase("tr-TR");
  }

  function expertPanel() {
    return document.querySelector(
      "#gdxPanelV4ResultPreview " +
      PANEL_SELECTOR
    );
  }

  function currentContextKey() {
    var ui =
      window.GDX_PANEL_LED_V4_UI ||
      {};

    var current =
      ui.state ||
      {};

    var selected =
      current.selected ||
      {};

    function productKey(product) {
      product = product || {};

      return clean(
        product.key ||
        product.handle ||
        product.id ||
        product.title
      );
    }

    return [
      productKey(selected[1]),
      productKey(selected[2]),
      clean(current.compareRenderedAt),
      clean(
        current.compareResult &&
        current.compareResult.ok
          ? "ok"
          : ""
      )
    ].join("::");
  }

  function personaState() {
    return (
      typeof window
        .getPanelV4R29V4ExpertCommentState ===
      "function"
    )
      ? window
          .getPanelV4R29V4ExpertCommentState()
      : null;
  }

  function ensureStyle() {
    if (document.getElementById(STYLE_ID)) {
      return;
    }

    var style =
      document.createElement("style");

    style.id =
      STYLE_ID;

    style.textContent = `
@media(min-width:761px){
  #gdx-panel-led-v4-root
  [data-gdx-panel-expert-comment="1"]
  > [data-gdx-panel-r29-v4-layout="1"]{
    display:grid !important;
    grid-template-columns:minmax(0,1fr) !important;
    gap:0 !important;
    align-items:stretch !important;
  }

  #gdx-panel-led-v4-root
  [data-gdx-panel-expert-comment="1"]
  [data-gdx-panel-r29-v4-expert-content="1"]{
    width:100% !important;
    min-width:0 !important;
  }

  #gdx-panel-led-v4-root
  [${DECISION_ATTR}="1"]{
    position:relative !important;
    min-height:196px !important;
    padding-right:198px !important;
    overflow:hidden !important;
  }

  #gdx-panel-led-v4-root
  [${DECISION_ATTR}="1"]
  > [data-gdx-panel-r29v-persona="expert_comment"]{
    position:absolute !important;
    top:50% !important;
    right:16px !important;
    width:164px !important;
    min-width:0 !important;
    max-width:164px !important;
    min-height:0 !important;
    margin:0 !important;
    transform:translateY(-50%) !important;
    display:flex !important;
    align-items:center !important;
    justify-content:center !important;
    pointer-events:none !important;
  }

  #gdx-panel-led-v4-root
  [${DECISION_ATTR}="1"]
  > [data-gdx-panel-r29v-persona="expert_comment"]
  [data-gdx-panel-r29v-image="expert_comment"]{
    display:block !important;
    width:100% !important;
    height:auto !important;
    max-height:182px !important;
    object-fit:contain !important;
    object-position:center !important;
  }
}

@media(min-width:1180px){
  #gdx-panel-led-v4-root
  [${DECISION_ATTR}="1"]{
    min-height:214px !important;
    padding-right:242px !important;
  }

  #gdx-panel-led-v4-root
  [${DECISION_ATTR}="1"]
  > [data-gdx-panel-r29v-persona="expert_comment"]{
    right:20px !important;
    width:204px !important;
    max-width:204px !important;
  }

  #gdx-panel-led-v4-root
  [${DECISION_ATTR}="1"]
  > [data-gdx-panel-r29v-persona="expert_comment"]
  [data-gdx-panel-r29v-image="expert_comment"]{
    max-height:218px !important;
  }
}

@media(max-width:760px){
  #gdx-panel-led-v4-root
  [data-gdx-panel-expert-comment="1"]
  > [data-gdx-panel-r29-v4-layout="1"]{
    display:grid !important;
    grid-template-columns:1fr !important;
    gap:10px !important;
  }

  #gdx-panel-led-v4-root
  [${DECISION_ATTR}="1"]{
    min-height:0 !important;
    padding-right:inherit !important;
    overflow:visible !important;
  }
}
`;

    document.head.appendChild(style);
  }

  function clearDecisionOwners() {
    Array.prototype.slice.call(
      document.querySelectorAll(
        "[" + DECISION_ATTR + '="1"]'
      )
    ).forEach(function (node) {
      node.removeAttribute(
        DECISION_ATTR
      );
    });
  }

  function findDecisionCard(content) {
    if (!content) {
      return null;
    }

    var headings =
      Array.prototype.slice.call(
        content.querySelectorAll(
          "h2,h3,h4,h5,h6,strong"
        )
      );

    var heading =
      headings.find(function (node) {
        return upper(node.textContent)
          .indexOf("SATIN ALMA KARARI") > -1;
      });

    if (!heading) {
      return null;
    }

    var node =
      heading.parentElement;

    var fallback =
      null;

    while (
      node &&
      node !== content
    ) {
      if (node.querySelector("p")) {
        fallback = node;
      }

      var style =
        window.getComputedStyle
          ? window.getComputedStyle(node)
          : null;

      if (
        node.querySelector("p") &&
        style &&
        parseFloat(
          style.borderTopWidth || "0"
        ) > 0 &&
        parseFloat(
          style.borderRadius || "0"
        ) >= 8
      ) {
        return node;
      }

      node =
        node.parentElement;
    }

    return fallback;
  }

  function place() {
    ensureStyle();

    var panel =
      expertPanel();

    if (!panel) {
      return false;
    }

    var layout =
      panel.querySelector(
        ":scope > " + LAYOUT_SELECTOR
      );

    var content =
      panel.querySelector(
        CONTENT_SELECTOR
      );

    var host =
      panel.querySelector(
        HOST_SELECTOR
      );

    if (
      !layout ||
      !content ||
      !host
    ) {
      return false;
    }

    clearDecisionOwners();

    if (
      window.matchMedia(
        "(min-width:761px)"
      ).matches
    ) {
      var decisionCard =
        findDecisionCard(content);

      if (!decisionCard) {
        return false;
      }

      decisionCard.setAttribute(
        DECISION_ATTR,
        "1"
      );

      panel.setAttribute(
        MODE_ATTR,
        "desktop_decision_card"
      );

      decisionCard.appendChild(host);

      return true;
    }

    panel.setAttribute(
      MODE_ATTR,
      "mobile_top"
    );

    layout.appendChild(host);

    return true;
  }

  function needsRefresh() {
    var panel =
      expertPanel();

    var host =
      panel &&
      panel.querySelector(
        HOST_SELECTOR
      );

    var image =
      panel &&
      panel.querySelector(
        IMAGE_SELECTOR
      );

    var state =
      personaState();

    var currentKey =
      currentContextKey();

    return !(
      panel &&
      host &&
      image &&
      state &&
      state.contextKey === currentKey &&
      state.status === "persona_ready" &&
      state.imageVisible === true
    );
  }

  function refreshPersona() {
    if (
      typeof window
        .refreshPanelV4R29V4ExpertCommentPersona ===
      "function"
    ) {
      try {
        window
          .refreshPanelV4R29V4ExpertCommentPersona();
      } catch (ignore) {}
    }
  }

  function attempt(token, index) {
    if (token !== runToken) {
      return;
    }

    if (needsRefresh()) {
      refreshPersona();
    }

    Promise.resolve().then(place);

    if (index >= delays.length - 1) {
      return;
    }

    window.setTimeout(
      function () {
        attempt(
          token,
          index + 1
        );
      },
      delays[index + 1] -
      delays[index]
    );
  }

  function start() {
    runToken += 1;

    attempt(
      runToken,
      0
    );
  }

  function bottomFixedOrStickyAncestor(control) {
    var node =
      control;

    var depth =
      0;

    while (
      node &&
      depth < 8
    ) {
      var style =
        window.getComputedStyle
          ? window.getComputedStyle(node)
          : null;

      var rect =
        node.getBoundingClientRect
          ? node.getBoundingClientRect()
          : null;

      if (
        style &&
        rect &&
        (
          style.position === "fixed" ||
          style.position === "sticky"
        ) &&
        rect.bottom >=
          window.innerHeight - 56 &&
        rect.top >
          window.innerHeight * 0.38
      ) {
        return true;
      }

      node =
        node.parentElement;

      depth += 1;
    }

    return false;
  }

  function relevantAction(target) {
    if (
      !target ||
      !target.closest
    ) {
      return false;
    }

    var control =
      target.closest(
        "button,a,[role='button']," +
        "[data-gdx-panel-compare-action='1']," +
        "[data-gdx-panel-sticky-action]," +
        "[data-gdx-panel-dock-action]," +
        "#gdxPanelV4CompareBtn"
      );

    if (!control) {
      return false;
    }

    var text =
      upper(
        control.innerText ||
        control.textContent ||
        ""
      );

    if (
      text.indexOf(
        "GENEL F/P KARŞILAŞTIR"
      ) > -1 ||
      text.indexOf(
        "YENİ KARŞILAŞTIRMA YAP"
      ) > -1
    ) {
      return true;
    }

    if (
      control.closest(
        "[data-gdx-panel-sticky]," +
        "[data-gdx-panel-bottom-dock]," +
        "[data-gdx-panel-compare-dock]," +
        ".gdx-panel-v4-sticky," +
        ".gdx-panel-v4-bottom-dock," +
        ".gdx-panel-v4-compare-dock"
      )
    ) {
      return true;
    }

    return bottomFixedOrStickyAncestor(
      control
    );
  }

  document.addEventListener(
    "click",
    function (event) {
      if (
        relevantAction(
          event.target
        )
      ) {
        start();
      }
    },
    true
  );

  window.addEventListener(
    "gdx-panel-v4-r28-selection-change",
    start
  );

  window.addEventListener(
    "pageshow",
    start,
    { once: true }
  );

  var media =
    window.matchMedia(
      "(min-width:761px)"
    );

  if (
    media &&
    typeof media.addEventListener ===
      "function"
  ) {
    media.addEventListener(
      "change",
      start
    );
  }

  window
    .refreshPanelV4R29V4R4Recovery =
      start;

  window
    .debugPanelV4R29V4R4Recovery =
      function () {
        var panel =
          expertPanel();

        var layout =
          panel &&
          panel.querySelector(
            ":scope > " + LAYOUT_SELECTOR
          );

        var content =
          panel &&
          panel.querySelector(
            CONTENT_SELECTOR
          );

        var host =
          panel &&
          panel.querySelector(
            HOST_SELECTOR
          );

        var image =
          panel &&
          panel.querySelector(
            IMAGE_SELECTOR
          );

        var decisionCard =
          panel &&
          panel.querySelector(
            "[" + DECISION_ATTR + '="1"]'
          );

        var isDesktop =
          window.matchMedia(
            "(min-width:761px)"
          ).matches;

        var state =
          personaState();

        var checks = {
          recoveryAssetReady:
            window[READY_KEY] === true,

          expertPanelPresent:
            !!panel,

          layoutPresent:
            !!layout,

          contentPresent:
            !!content,

          exactlyOneHost:
            document.querySelectorAll(
              HOST_SELECTOR
            ).length === 1,

          exactlyOneImage:
            document.querySelectorAll(
              IMAGE_SELECTOR
            ).length === 1,

          currentContextMatched:
            !!(
              state &&
              state.contextKey ===
              currentContextKey()
            ),

          personaReady:
            !!(
              state &&
              state.status ===
                "persona_ready" &&
              state.imageVisible ===
                true
            ),

          imageLoaded:
            !!(
              image &&
              image.complete &&
              image.naturalWidth > 0
            ),

          desktopHostInsideDecisionCard:
            !isDesktop ||
            !!(
              decisionCard &&
              host &&
              decisionCard.contains(host)
            ),

          mobileHostInsideLayout:
            isDesktop ||
            !!(
              layout &&
              host &&
              layout.contains(host)
            ),

          noMutationObserver:
            true,

          noRecurringInterval:
            true,

          noScoreMutation:
            true,

          noRankingMutation:
            true,

          noProductMutation:
            true,

          noCartMutation:
            true,

          noSetupMutation:
            true,

          noShareMutation:
            true
        };

        var failed =
          Object.keys(checks)
            .filter(function (key) {
              return checks[key] !== true;
            });

        return {
          phase:
            "PANEL-V4-R29-V4-R4-EXPERT-NORA-SECOND-COMPARISON-RECOVERY",
          ok:
            failed.length === 0,
          checks:
            checks,
          diagnostics: {
            failed:
              failed,
            mode:
              panel
                ? panel.getAttribute(
                    MODE_ATTR
                  )
                : "",
            currentContextKey:
              currentContextKey(),
            state:
              state,
            currentImageUrl:
              clean(
                image &&
                image.src
              )
          }
        };
      };

  ensureStyle();
  start();
})(window, document)
